import axios from "axios";
import { Stack, Grid, DialogTitle, DialogActions, Box, Typography, Modal } from '@mui/material';
import Button from '@mui/material/Button';
import { useCallback, useEffect, useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import PrintIcon from '@mui/icons-material/Print';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LandingPageTable from "./LandingPageTable";
import { Autocomplete, Dialog, TextField } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CircularProgress from '@mui/material/CircularProgress';
import SendMailModal from "./SendMailModal";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import apiKeys from '../assets/Json/ApiKey.json';
import { type } from "@testing-library/user-event/dist/type";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function View3() {
  const [selectedProjectName, setSelectedProjectName] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [projectOption, setProjectOption] = useState([]);
  const [changesKey, setChangesKey] = useState(false);
  const [iframeFlag, setIframeFlag] = useState(false);
  const [handleFlag, setHandleFlag] = useState(false);
  const [loaderForAddtocart, setLoaderForAddtocart] = useState(false);
  const [getData, setGetData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [open, setOpen] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [mailDialog, setOpenMailDialog] = useState(false);
  const [templateString, setTemplateString] = useState("");
  const [catalogString, setCatalogString] = useState("");
  const [dataForEmail, setDataForEmail] = useState({})
  const [validationList, setValidationList] = useState({})
  const [catalogDataFromUrl, setCatalogDataFromUrl] = useState([])
  const [itemPasteState, setItemPasteState] = useState([])
  const [catalogDataFlag, setCatalogDataFlag] = useState(false)
  const [showOnlineBuy, setShowOnlineBuy] = useState("");
  const [homePageURl, SetHomePageURl] = useState("");

  const notify = (message) => toast(message);

  useEffect(() => {
    const Key = new URLSearchParams(window.location.search)

    const apiKey = Key?.get("apiKey")
    const lang = Key?.get("lang")
    const productKey = Key?.get("prod")

    if (apiKey && productKey) {
      localStorage.setItem("handleValue", JSON.stringify(1))
      setShowOnlineBuy(true)
      // SetHomePageURl(`http://localhost:3001/?apiKey=${apiKey}&prod=${productKey}${lang? '&lang='+lang:''}`)
      SetHomePageURl(`https://ezlist.schneider-electric.com/cnst.php?prod=${productKey}&apiKey=${apiKey}${lang? '&lang='+lang:''}`)
      setHandleFlag(true)
      setIframeFlag(true)

    } else if (apiKey) {
      // SetHomePageURl(`http://localhost:3001/?apiKey=${apiKey}${lang? '&lang='+lang:''}`)
      // SetHomePageURl(`https://ezlist.schneider-electric.com/cnst.php?apiKey=${apiKey}${lang? '&lang='+lang:''}`)
      SetHomePageURl(`https://tools.se.app/ez/ez3/prd/homepage/index.html?apiKey=${apiKey}${lang? '&lang='+lang:''}`)
    }
    else if (productKey) {
      localStorage.setItem("handleValue", JSON.stringify(1))
      SetHomePageURl(`https://ezlist.schneider-electric.com/cnst.php?prod=${productKey}${lang? '&lang='+lang:''}`)
      // SetHomePageURl(`http://localhost:3001/?prod=${productKey}${lang? '&lang='+lang:''}`)
      setIframeFlag(true)
      setHandleFlag(true)
    }
    else {
      setShowOnlineBuy(false)
      // SetHomePageURl(`http://localhost:3001/${lang? '&lang='+lang:''}`)
      SetHomePageURl(`https://tools.se.app/ez/ez3/prd/homepage/index.html${lang? '&lang='+lang:''}`)
      //SetHomePageURl(`https://d2jy1wamzppd9c.cloudfront.net/ez/ez3/qa/homepage1/index.html${lang? '&lang='+lang:''}`)
    }


    const newPrjt = Key?.get("newproj")
    const newItem = Key?.get("newitem")

    if (newPrjt != null && newItem != null) {
      const splitData = newItem.split(";")
      const fetchdata = async () => {
        const getdata = await axios.all(splitData.map((endpoint) => axios.get(`https://api.channelsight.com/api/1.22/feed?key=849fcecd-306f-41c0-b423-5670a82d9777&assetId=814&pid=${endpoint.split(',')[1]}`))).then(
          (data) => data
        );
        if (getdata.length > 0) {
          var appendData = []
          getdata.forEach(element => {
            if (element?.data[0]?.RetailerProducts?.length > 0) {
              appendData.push({
                catalogNo: element?.data[0].ProductId,
                dataSheetUrl: `https://eref.se.com/us/en/scope/product/${element?.data[0].ProductId}`,
                description: element?.data[0].ProductDescription,
                designation: "final-part",
                pictureUrl: element?.data[0].MainImageUrl
              })
            }

          });
          setCatalogDataFromUrl([...appendData])
        }
      }
      fetchdata()
    }
  }, [])

  useEffect(() => {
    const Key = new URLSearchParams(window.location.search)
    const newPrjt = Key?.get("newproj")
    const newItem = Key?.get("newitem")
    const prjtAry = newItem?.split(";")
    if (!catalogDataFlag && catalogDataFromUrl.length > 0) {
      let preparedNewArrayData = []
      if (catalogDataFromUrl.length > 0) {
        catalogDataFromUrl.forEach((element, indx) => {
          if (element.catalogNo === prjtAry[indx].split(",")[1]) {
            element.quantity = parseInt(prjtAry[indx].split(",")[0])
            preparedNewArrayData[element.catalogNo] = element
          }

        });
      }
      let preparedDataList = []
      prjtAry.forEach(element => {
        if (element.split(",")[1] === preparedNewArrayData[element?.split(",")[1]]?.catalogNo) {
          preparedDataList.push(preparedNewArrayData[element.split(",")[1]])
        }
      })

      const projectname = JSON.parse(localStorage.getItem("projectname")) ? JSON.parse(localStorage.getItem("projectname")) : []
      const addtocartdata = JSON.parse(localStorage.getItem("addtocartdata")) ? JSON.parse(localStorage.getItem("addtocartdata")) : []

      if (preparedDataList.length > 0) {
        if (projectname.includes(newPrjt)) {
          projectname.push(`${newPrjt}(1)`)
          localStorage.setItem("seletedprjt", JSON.stringify(`${newPrjt}(1)`))
          addtocartdata.push({ [`${newPrjt}(1)`]: preparedDataList })
        } else {
          projectname.push(newPrjt)
          localStorage.setItem("seletedprjt", JSON.stringify(newPrjt))
          addtocartdata.push({ [newPrjt]: preparedDataList })
        }
        localStorage.setItem("projectname", JSON.stringify(projectname))
        localStorage.setItem("addtocartdata", JSON.stringify(addtocartdata))
      }
      setCatalogDataFromUrl([])
      setCatalogDataFlag(true)
      window.location.replace(`https://tools.se.app/ez/ez3/prd/landingpage/index.html`);
      // window.location.replace(`http://localhost:3000`);
    }


  }, [catalogDataFromUrl])


  useEffect(() => {
    const seletedprjt = JSON.parse(localStorage.getItem("seletedprjt"))
    if (seletedprjt == null) {
      const TodayDate = new Date()
      const day = String(TodayDate.getDate()).padStart(2, '0')
      const month = String(TodayDate.getMonth() + 1).padStart(2, '0');
      const year = TodayDate.getFullYear()
      setProjectOption([`Project-${year}.${month}.${day}`])
      setProjectName("Project-1")
      localStorage.setItem("seletedprjt", JSON.stringify(`Project-${year}.${month}.${day}`))
      localStorage.setItem("projectname", JSON.stringify([`Project-${year}.${month}.${day}`]))
    }
    handleChangesData(seletedprjt)
  }, [])




  const handleChange = (event, value) => {
    setSelectedProjectName(value);
    localStorage.setItem("seletedprjt", JSON.stringify(value))
    handleChangesData(value)
  };

  const handleChangesData = async (value = "") => {
    setRowData([])
    const LocalProjectname = JSON.parse(localStorage.getItem("seletedprjt"))
    const getDataforhandle = JSON.parse(localStorage.getItem("addtocartdata"))

    if (getDataforhandle?.length > 0) {
      getDataforhandle.forEach((Data, idx) => {
        if (Object.keys(Data)[0] === LocalProjectname) {
          setLoaderForAddtocart(false)
          setRowData(Data[LocalProjectname])

        }
      })
    } else {
      setRowData([])
    }
  }


  const handleSaveProject = () => {
    const getporjectname = JSON.parse(localStorage.getItem("projectname"))
    const prvsProject = JSON.parse(localStorage.getItem("seletedprjt"))
    const prvsAddcartProjt = JSON.parse(localStorage.getItem("addtocartdata"))

    if (!getporjectname?.includes(projectName)) {
      if (!changesKey) {
        var assignArray = []
        assignArray.push(projectName)

        if (getporjectname !== null) {
          const appendArray = assignArray.concat(getporjectname);
          localStorage.setItem("projectname", JSON.stringify(appendArray))
        } else {
          localStorage.setItem("projectname", JSON.stringify(assignArray))
        }
        notify("Project is successfully added")
      } else {
        const FindIndex = getporjectname.indexOf(prvsProject)
        getporjectname[FindIndex] = projectName
        localStorage.setItem("projectname", JSON.stringify(getporjectname))

        if (prvsAddcartProjt?.length > 0) {
          prvsAddcartProjt?.map((getPrjt, Idx) => {
            if (getPrjt[prvsProject]) {
              getPrjt[projectName] = getPrjt[prvsProject]
              delete getPrjt[prvsProject];
            }
          })
          localStorage.setItem("addtocartdata", JSON.stringify(prvsAddcartProjt))
        }
        setChangesKey(false)
        notify("Project is successfully updated.")
      }
    } else {
      notify(`The project name ${projectName} is already exists`)
    }
    setSelectedProjectName(projectName);
    localStorage.setItem("seletedprjt", JSON.stringify(projectName))
    const getAllporjectnames = JSON.parse(localStorage.getItem("projectname"))
    setProjectOption([...getAllporjectnames])
    setOpen(false)
    handleChangesData(projectName)
  }

  useEffect(() => {
    const getAllporjectname = JSON.parse(localStorage.getItem("projectname"))
    if (getAllporjectname != null && getAllporjectname.length > 0) {
      setProjectOption([...getAllporjectname])
    }
    const getseletedProjectName = JSON.parse(localStorage.getItem("seletedprjt"))
    if (getseletedProjectName != null) {
      setSelectedProjectName(getseletedProjectName)
      // handleChangesData(getseletedProjectName)
    }

  }, [])


  const handleEditProjectName = () => {
    setChangesKey(true)
    const getseletedProjectNameforEdit = JSON.parse(localStorage.getItem("seletedprjt"))
    setProjectName(getseletedProjectNameforEdit)
    setOpen(true)

  }

  const handleAddProject = () => {
    setOpen(true);
    setProjectName("")
  }

  const handleClose = () => {
    setOpen(false);
    setChangesKey(false)
    // setIframeFlag(prevState => {
    //   return !prevState;
    // });
    setIframeFlag(false)
    setHandleFlag(false)
    localStorage.setItem("handleValue", JSON.stringify(0));
  }

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false)
  }
  const handleOpenDeleteDialog = () => {
    setOpenDeleteDialog(true)
  }

  const handleDeleteProjectName = () => {
    const allProjectNames = JSON.parse(localStorage.getItem("projectname")) || []
    const updatedProjectNames = allProjectNames.filter(name => name !== selectedProjectName)

    localStorage.setItem("projectname", JSON.stringify(updatedProjectNames))
    const newSelectedProjectName = updatedProjectNames[0] || ""
    localStorage.setItem("seletedprjt", JSON.stringify(newSelectedProjectName))

    setSelectedProjectName(newSelectedProjectName);
    setProjectOption([...updatedProjectNames])

    const previousAddCartProjects = JSON.parse(localStorage.getItem("addtocartdata")) || []
    if (previousAddCartProjects) {
      const updatedCartProjects = previousAddCartProjects.filter((i) => Object.keys(i)[0] !== selectedProjectName)
      localStorage.setItem("addtocartdata", JSON.stringify(updatedCartProjects))
      handleChangesData(newSelectedProjectName)
    }
    notify("Project is successfully deleted.")
    setOpenDeleteDialog(false)
  }


  const handleAddItem = (data) => {
    if (!handleFlag) return
    localStorage.setItem("handleValue", JSON.stringify(0))
    setHandleFlag(false)

    const prevAddcartList = JSON.parse(localStorage.getItem("addtocartdata")) || []
    const selectedProject = JSON.parse(localStorage.getItem("seletedprjt"));
    const newCartItem = { [selectedProject]: data }

    const updatedCart = mergeCartItems(prevAddcartList, newCartItem);
    handleLoader()

    localStorage.setItem("addtocartdata", JSON.stringify(updatedCart))
    handleChangesData(projectName)
    setTimeout(() => {
      handleLoader()
    }, 10000);
    notify("Item(s) are successfully added into cart.")
    setLoaderForAddtocart(false)
    setItemPasteState([])

  }

  const mergeCartItems = (prevList, newItem) => {
    const addtocartArray = {};

    prevList.concat([newItem]).forEach(item => {
      const projectName = Object.keys(item)[0];
      const projectItems = item[projectName];

      if (!addtocartArray[projectName]) {
        addtocartArray[projectName] = [];
      }

      const existingItemsMap = addtocartArray[projectName].reduce((map, item, index) => {
        map[item.catalogNo] = { ...item, index };
        return map;
      }, {});

      projectItems.forEach(product => {
        if (existingItemsMap[product.catalogNo]) {
          const existingItem = existingItemsMap[product.catalogNo];
          addtocartArray[projectName][existingItem.index].quantity += product.quantity;
        } else {
          addtocartArray[projectName].push(product);
        }
      });
    })

    return Object.keys(addtocartArray).map(key => ({ [key]: addtocartArray[key] }));
  }



  const handleLoader = () => {
    // setLoaderForAddtocart("false")
  }

  const handleIncrease = (index, page, perPage) => {
    const RowIndex = page * perPage + index
    let AddcartProjts = JSON.parse(localStorage.getItem("addtocartdata"))
    AddcartProjts.forEach((Data, I) => {
      if (Data[selectedProjectName]) {
        Data[selectedProjectName][RowIndex].quantity = Data[selectedProjectName][RowIndex].quantity + 1
      }
    })
    localStorage.setItem("addtocartdata", JSON.stringify(AddcartProjts))
    handleChangesData(selectedProjectName)

  }

  const handleDecrease = (index, page, perPage) => {
    const RowIndex = page * perPage + index
    let AddcartProjts = JSON.parse(localStorage.getItem("addtocartdata"))
    AddcartProjts.forEach((Data, I) => {
      if (Data[selectedProjectName]) {
        Data[selectedProjectName][RowIndex].quantity = Data[selectedProjectName][RowIndex].quantity - 1
      }
    })
    localStorage.setItem("addtocartdata", JSON.stringify(AddcartProjts))
    handleChangesData(selectedProjectName)
  }

  const handleDeletefromTable = (id) => {
    let AddcartProjtforDelete = JSON.parse(localStorage.getItem("addtocartdata"))
    let filterProject = AddcartProjtforDelete.filter(P => Object.keys(P)[0] == selectedProjectName)

    let PreparedNewArray = []
    filterProject[0][selectedProjectName].forEach((D, Idx) => {
      if (!id.includes(D.catalogNo)) {
        PreparedNewArray.push(D)
      }
    })
    filterProject[0][selectedProjectName] = PreparedNewArray
    localStorage.setItem("addtocartdata", JSON.stringify(AddcartProjtforDelete))
    handleChangesData(selectedProjectName)
    notify("Item(s) are successfully deleted from cart.")
  }

  const handleAddItems = () => {
    localStorage.setItem("handleValue", JSON.stringify(1));

    const urlParamKeys  = new URLSearchParams(window.location.search);
    const hpApiKey      = urlParamKeys?.get("apiKey");
    const hpLang        = urlParamKeys?.get("lang");

    var hpParamStr  = '';
    if(hpApiKey && hpLang)
      hpParamStr  = `?apiKey=${hpApiKey}&lang=${hpLang}`;
    else if(hpApiKey)
      hpParamStr  = `?apiKey=${hpApiKey}`;
    else if(hpLang)
      hpParamStr  = `?lang=${hpLang}`;

    SetHomePageURl(`https://tools.se.app/ez/ez3/prd/homepage/index.html${hpParamStr}`);
  }

  const handlePrint = () => {

    const contentToPrint = document.getElementById('myPrintableDiv');

    if (contentToPrint) {
      const printWindow = window.open('https://tools.se.app/ez/ez3/qa/landingpage/index.html', '_blank');

      // Hide the element with class name "landing_page" in the new window
      const landingPageElement = printWindow.document.querySelector(".landing_page");
      if (landingPageElement) {
        landingPageElement.style.display = "none";
      }


      printWindow.document.write('<html><head><title>Print</title><link rel="stylesheet" href="https://tools.se.app/ez/ez3/qa/landingpage/App.css" ><link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"></head><body>');
      // document.write('<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />');
      printWindow.document.write(contentToPrint.innerHTML);
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      // Print the content in the new window
      printWindow.print();

      // Close the new window after printing
      printWindow.close();
    } else {
      console.error("Couldn't find the element with id 'myPrintableDiv'");
    }
  }

  const EZReceiveMessage = useCallback((event) => {

    const { fn, data } = event.data;
    const handleValue = JSON.parse(localStorage.getItem("handleValue"));

    if (fn !== undefined && handleValue === 1) {
      const parsedData = typeof data === 'string' && data !== '' ? JSON.parse(data) : data;
      const isValidData = data?.length > 0 && !parsedData.hasOwnProperty('Parts') && !parsedData.hasOwnProperty('Accessories');

      switch (fn) {
        case "EZAddToHome":
          if (handleFlag && isValidData) {
            handleAddItem(parsedData);
            setIframeFlag(false);
            setGetData(parsedData);
          }
          break;
        case "EZClose":
          setIframeFlag(false);
          handleClose();
          break;
        case "cnsClose":
          setIframeFlag(false);
          handleClose();
          // localStorage.setItem("handleValue", JSON.stringify(0));
          break;
        case "cnsAddToProject":
          if (handleFlag && isValidData) {
            handleAddItem(parsedData);
            setIframeFlag(false);
            setGetData(parsedData);
          }
          break;
        case "cnsSolution":
          break;
        default:
          break;
      }
    }
  }, [handleFlag]);

  useEffect(() => {
    // localStorage.setItem("handleValue", JSON.stringify(0));

    window.addEventListener("message", EZReceiveMessage);

    return () => {
      window.removeEventListener("message", EZReceiveMessage);
    };
  }, [window.addEventListener("message", EZReceiveMessage)]);


  const handleSendMail = (data) => {
    if (checkAllValidation()) {
      setLoaderForAddtocart(true)
      axios.post('https://kff9rd10y0.execute-api.us-east-2.amazonaws.com/prd/sendezlistmail', {
        fromAddress: data.from,
        materialList: `<pre class="code">
          <p style="font-size: 14px;font-weight: normal;"><b>Respond to: <a href="mailto:${data.to}?subject=test: Material List">${data.to}</a></b></p>
          <pre class="code">
              <p style="font-size: 14px;font-weight: normal;">${data.message}</p>
              <table style="border-collapse: collapse;width:100%;margin-top:8px;border: 1px solid;border-color: black;">
              <thead>
                  <tr><th style="height: 50px;background-color:#28B779;color:#ffffff;border-right: 1px solid green;border-bottom: 1px solid black;font-size: 16px;font-weight: bold;">Qty</th><th style="height: 50px;background-color:#28B779;color:#ffffff;border-right: 1px solid green;border-bottom: 1px solid black;font-size: 16px;font-weight: bold;">Catalog Number</th><th style="height: 50px;background-color:#28B779;color:#ffffff;border-right: 1px solid green;border-bottom: 1px solid black;font-size: 16px;font-weight: bold;">Description</th></tr>
              </thead>
              <tbody id="materialListBody">
                ${templateString.toString()}
              </tbody>
          </table>
              <div id="emailLink" style="\"><a id="emailNewProjectLink" href="https://tools.se.app/ez/ez3/qa/landingpage/index.html?newproj=${selectedProjectName}&amp;newitem=${catalogString}" target="_blank" style="font-size: 14px;font-weight: normal;">Open this link to import this project list</a></div>
              <p style="font-size: 14px;font-weight: normal;">Material list created by Schneider Electric EZ Selection Tool [project# <b>${selectedProjectName}</b>]</p>
            
              <i style="font-size: 14px;">This is an auto generated email. Please do not reply to this email.</i>
              <br>
              <p style="font-size: 14px;font-weight: normal;">Thank you,</p>
              <p style="font-size: 14px;font-weight: normal;">Schneider Electric</p>
              <p><img src="https://ezlist.schneider-electric.com/EZ/Schneider/images/se-life-is-on_New.png"></p>
              </pre>
          </pre>`,
        projectList: catalogString.toString(),
        projectNo: selectedProjectName,
        subject: "test: Material List",
        toAddress: data.to
      })
        .then((response) => {
          if (response.status == 200) {
            setTemplateString("")
            setOpenMailDialog(false)
            notify(response.data)
            setDataForEmail({})
            setLoaderForAddtocart(false)
          }
        }, (error) => {
          console.log("error", error);
          setLoaderForAddtocart(false)
        });
    } else {
    }

  }


  const handlePrepareTempalete = () => {

    let TemplateString = "";
    let CatalogDetails = "";
    rowData.forEach((element, idx) => {
      var LabelHtml = `<tr style="background-color:#CEEFDD;color: #000000;"><td style="border-right: 1px solid green;border-top: 1px solid #28B779;font-size: 14px;font-weight: normal;">${element.quantity}</td><td style="border-right: 1px solid green;border-top: 1px solid #28B779;font-size: 14px;font-weight: normal;">${element.catalogNo}</td><td style="border-top: 1px solid #28B779;font-size: 14px;font-weight: normal;">${element.description}</td>
      </tr>`
      if (rowData.length === idx) {
        var catalogObj = `${element.quantity},${element.catalogNo}`
      } else {
        catalogObj = `${element.quantity},${element.catalogNo};`
      }

      CatalogDetails = CatalogDetails + catalogObj;
      TemplateString = TemplateString + LabelHtml;
    });
    let newString = CatalogDetails.substring(0, CatalogDetails.length - 1)
    setTemplateString(TemplateString)
    setCatalogString(newString)
  }

  const checkAllValidation = () => {

    var tofrom = !validateField("toFrom");
    var from = !validateField("from");

    tofrom = !/^\S+@\S+\.\S+$/.test(dataForEmail.to)
    from = !/^\S+@\S+\.\S+$/.test(dataForEmail.from)

    setValidationList({
      tofrom,
      from
    });

    return (
      !tofrom &&
      !from
    );

  };


  const validateField = (field) => {
    let isValid = true;
    if (
      (!dataForEmail[field] ||
        dataForEmail[field] === "" ||
        dataForEmail[field] === null ||
        (dataForEmail[field] && dataForEmail[field].length === 0))
      && dataForEmail.hasOwnProperty(field)
    ) {
      setValidationList({ ...validationList, [field]: true });
      isValid = false;
    } else {
      setValidationList({ ...validationList, [field]: false });
    }
    return isValid;
  };

  const handleCopyProject = () => {
    const getseletedProjectName = JSON.parse(localStorage.getItem("seletedprjt"))
    const prjtName = JSON.parse(localStorage.getItem("projectname"))
    prjtName.push(`${getseletedProjectName}(1)`)
    localStorage.setItem("seletedprjt", JSON.stringify(`${getseletedProjectName}(1)`))
    localStorage.setItem("projectname", JSON.stringify(prjtName))
    setProjectOption([...projectOption, `${getseletedProjectName}(1)`])
    setSelectedProjectName(`${getseletedProjectName}(1)`)
    handleChangesData()
  }

  const handlePasteItem = () => {
    setHandleFlag(true);
    handleAddItem(itemPasteState)
  }



  return (
    <>
      {<div>
        <Grid container>
          <Grid item xs={12} md={12}>
            <div className="landing_main_view">
              <div className="landing_page">
                <Stack spacing={2} direction="row">
                  <Button variant="outlined" className="add_item_button" disabled={projectOption.length !== 0 ? false : true} onClick={() => { handleAddItems(); setIframeFlag(true); setHandleFlag(true) }} ><AddCircleIcon />  ADD ITEM</Button>
                  <Autocomplete
                    value={selectedProjectName}
                    onChange={(event, newValue) => {
                      handleChange(event, newValue);
                    }}
                    id="controllable-states-demo"
                    options={projectOption}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="Project" />}
                  />
                  <Button variant="outlined" onClick={() => handleAddProject()}><AddCircleIcon />ADD PROJECT</Button>
                  <Button variant="outlined" onClick={() => handleEditProjectName()} disabled={projectOption.length !== 0 ? false : true} ><EditIcon /> RENAME PROJECT </Button>
                  <Button variant="outlined" onClick={() => handleOpenDeleteDialog()} disabled={projectOption.length !== 0 ? false : true}><DeleteIcon /> DELETE PROJECT </Button>
                  <Button variant="outlined" onClick={() => handleCopyProject()} disabled={projectOption.length !== 0 ? false : true}><ContentCopyIcon /> COPY PROJECT </Button>
                </Stack>
                <Stack spacing={2} direction="row">
                  <Button variant="outlined" onClick={() => handlePrint()}><PrintIcon />PRINT</Button>
                  <Button variant="outlined" onClick={() => { setOpenMailDialog(true); handlePrepareTempalete(); setDataForEmail({}) }}><MailOutlineIcon />SHARE</Button>
                </Stack>
              </div>
              <div id="myPrintableDiv">
                <LandingPageTable rows={typeof (rowData) === "string" ? JSON.parse(rowData) : rowData} selectedProjectName={selectedProjectName} handleIncrease={handleIncrease} handleDecrease={handleDecrease} handleDeletefromTable={handleDeletefromTable} setItemPasteState={setItemPasteState} itemPasteState={itemPasteState} setHandleFlag={setHandleFlag} handlePasteItem={handlePasteItem} showOnlineBuy={showOnlineBuy} />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>}
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="project_modal"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {changesKey ? "Update Project Name" : "Project Name"}
          </Typography>
          <div className="product_input_box">
            <TextField id="outlined-basic" label="Project" variant="outlined" value={projectName} onChange={(e) => setProjectName(e.target.value)} />
          </div>
          <Stack spacing={2} direction="row" className="save_cancel_button">
            <Button variant="contained" disabled={projectName.length > 0 ? false : true} onClick={() => handleSaveProject()}>{changesKey ? "UPDATE" : "SAVE"}</Button>
            <Button variant="contained" onClick={() => handleClose()}>Cancel</Button>
          </Stack>
        </Box>
      </Modal>
      <ToastContainer />
      <Dialog className="iframDialog" open={iframeFlag} onClose={handleClose}>
        <div className="ez3-iframe-wrap">
          <iframe crossOrigin="true" src={homePageURl} className="landingPageIframe"></iframe>
        </div>
      </Dialog>
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="delete_content"
      >
        <DialogTitle id="alert-dialog-title">
          {rowData.length > 0 ? `This project contains ${rowData.length} item in the cart. Are you sure that you want to delete it permanently ?` : "Are you sure that you want to permanently delete the selected project?"}
        </DialogTitle>
        <DialogActions className="project_modal">
          <Button variant="contained" onClick={() => handleDeleteProjectName()} autoFocus>
            Delete
          </Button>
          <Button variant="contained" onClick={() => handleCloseDeleteDialog()}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <SendMailModal open={mailDialog} setOpne={setOpenMailDialog} handleSendMail={handleSendMail} dataForEmail={dataForEmail} setDataForEmail={setDataForEmail} loaderForAddtocart={loaderForAddtocart} validateField={validateField} validationList={validationList} setValidationList={setValidationList} />
      {loaderForAddtocart && <div className="loader_div">
        <CircularProgress disableShrink />{" "}
      </div>}
    </>
  );
}

export default View3;
